import { BackendModule } from "i18next"

const LazyImportPlugin: BackendModule = {
  type: "backend",
  init: (services, backendOptions, i18nextOptions) => {},
  read: (language, namespace, callback) => {
    import(/* webpackChunkName: "i18n/[request]" */ `./${language}/${namespace}.json`)
      .then(obj => callback(null, obj))
      .catch(() => callback(null, {}))
  },
}

export default LazyImportPlugin
